/**
 * @name getViewportWidth
 *
 * @description Returns the current viewport width in pixels
 *
 * @example
 * import { getViewportWidth } from '@workbench/core';
 *
 * getViewportWidth(); // 1024
 */
export function getViewportWidth(): number {
  return Math.max(window.document.documentElement.clientWidth || 0, window.innerWidth || 0);
}
